export interface Role {
    name: string;
}

export namespace RoleEnum {
    export enum Role {
        Administrator = 'Administrator',
    }

    export const ROLE_LIST: string[] = [
        Role.Administrator,
    ];
}
